/**
Author - Anubhav Agrawal
Git - https://github.com/annubhavWealthy
**/

import { WealthyEnv } from "helpers";

const WealthyOfficesList = [
  {
    isMainBranch: true,
    city: "Bengaluru",
    url: `${WealthyEnv.CDN_URL}/articles/blr-2.webp`,
    branchType: "Main Branch",
    address:
      "WealthyIN Broking Pvt Ltd (Head Office)<br />3rd Floor, Block B, No. 55/10, Harlukunte Village Sector 2 HSR Layout,<br />Bengaluru - 560102,<br />INDIA",
  },
  {
    isMainBranch: true,
    city: "Bengaluru",
    url: `${WealthyEnv.CDN_URL}/articles/blr-3.jpg`,
    branchType: "Main Branch",
    address:
      "BuildWealth Technologies Pvt Ltd <br /> 3rd Floor, Block B, No. 55/10, Harlukunte Village,  <br /> Sector 2, HSR layout, <br /> Bengaluru - 560102, <br /> INDIA",
  },
  {
    isMainBranch: true,
    city: "Bengaluru",
    url: `${WealthyEnv.CDN_URL}/articles/Bangalore.jpeg`,
    branchType: "Main Branch",
    address:
      "WealthyIN Customer Services Pvt Ltd <br /> #705, North Wing, Manipal Centre, <br /> Dickenson Road, <br /> Bengaluru - 560042, <br /> INDIA",
  },
  {
    isMainBranch: false,
    city: "Abu Dhabi",
    url: `${WealthyEnv.CDN_URL}/articles/Abu-Dhabi.jpeg`,
    branchType: "Sub Branch",
    address:
      "Etihad Airways Centre,  <br /> Al Muneera  <br /> PO Box - 767338, <br /> United Arab Emirates",
  },
  {
    isMainBranch: false,
    city: "Delhi",
    url: `${WealthyEnv.CDN_URL}/articles/Delhi.webp`,
    branchType: "Sub Branch",
    address:
      "BuildWealth Technologies Pvt Ltd <br /> Flat No. 801, Mercantile House,  <br /> 15 Kasturba Gandhi Marg, <br /> New Delhi - 110001, <br /> INDIA",
  },
  {
    isMainBranch: false,
    city: "Faridabad",
    url: `${WealthyEnv.CDN_URL}/articles/Faridabad.jpeg`,
    branchType: "Sub Branch",
    address:
      "WealthyIn Customer SCF No 43, <br/> First Floor, Sector-19, <br/> Part II, Huda Market, <br/> Faridabad, Haryana - 121002 <br /> INDIA",
  },
  {
    isMainBranch: false,
    city: "Ahmedabad",
    url: `${WealthyEnv.CDN_URL}/articles/Ahmedabad.jpeg`,
    branchType: "Sub Branch",
    address:
      "A-510, Shilp Corporate Park <br /> Rajpath-Rangoli Road, Bodakdev, Ahmedabad, <br /> Gujarat - 380054, <br /> INDIA",
  },
  {
    isMainBranch: false,
    city: "Jaipur",
    url: `${WealthyEnv.CDN_URL}/articles/jpr2.jpg`,
    branchType: "Sub Branch",
    address:
      "A-510, Shilp Corporate Park <br /> Rajpath-Rangoli Road, Bodakdev, <br /> Ahmedabad - 380054, <br /> INDIA",
    address:
      "WealthyIN Customer Services PVT Ltd PHOEBUS BUSINESS CENTRE <br />  Second Floor, K-12, Arcade, <br /> Malviya Marg, C-Scheme, Jaipur <br /> Rajasthan - 302001, <br /> INDIA",
  },
  {
    isMainBranch: false,
    city: "Hyderabad",
    url: `${WealthyEnv.CDN_URL}/articles/hyd2.jpg`,
    branchType: "Sub Branch",
    address:
      "Office unit no. G-2, <br/> Bearing Municipal No. #6-3-1085/D/G2, <br/> Dega Towers, Rajbhavan Road, Somajiguda, <br/> Hyderabad, Telangana - 500082 <br /> INDIA",
  },
  {
    isMainBranch: false,
    city: "Mumbai - Vasai",
    url: `${WealthyEnv.CDN_URL}/articles/Mumbai.webp`,
    branchType: "Sub Branch",
    address:
      "Shop No. 101 & 102, <br /> Ganpat Niwas Premises CHS Survey no. 16, <br /> Ambadi Road, Navghar, Vasai (West), <br />  Dist. Palghar, <br />  Mumbai, Maharashtra - 401202 <br/> INDIA",
  },
  {
    isMainBranch: false,
    city: "Mumbai - Dadar",
    url: `${WealthyEnv.CDN_URL}/articles/mumbai-2.jpg`,
    branchType: "Sub Branch",
    address:
      "301, Vasant Vihar Co-op. Housing Society Limited, <br /> Dadasaheb Phalke Road, <br/> Opp. BJP Office, Dadar East, <br /> Mumbai, Maharashtra - 400014 <br/> INDIA",
  },
  {
    isMainBranch: false,
    city: "Mumbai - Borivali",
    url: `${WealthyEnv.CDN_URL}/articles/mumbai-3.jpeg`,
    branchType: "Sub Branch",
    address:
      "Office No. 61, 6th floor, <br /> Om chambers, Final Plot No.209, <br/> TPS III, Taluka Borivali, in the Registration District of Mumbai Suburban District situated at 57th road, Borivali West, <br /> Mumbai, Maharashtra - 400092 <br/> INDIA",
  },
  {
    isMainBranch: false,
    city: "Kolkata",
    url: `${WealthyEnv.CDN_URL}/articles/kol2.webp`,
    branchType: "Sub Branch",
    address:
      "WealthyIn Customer Services Unit No. 6C, <br /> 6th floor of Central Plaza, no. 41, <br /> B.B. Ganguly Street, Kolkata <br /> West Bengal - 700012, <br/> INDIA",
  },
  {
    isMainBranch: false,
    city: "Lucknow",
    url: `${WealthyEnv.CDN_URL}/articles/Lucknow.jpeg`,
    branchType: "Sub Branch",
    address:
      "126/31,103-A 1st Floor, <br /> Shalimar Square, B.N Road, <br /> Lalbagh, Lucknow, <br /> Uttar Pradesh - 226001, <br /> INDIA",
  },
  {
    isMainBranch: false,
    city: "Gurugram",
    url: `${WealthyEnv.CDN_URL}/articles/Gurgaon.jpg`,
    branchType: "Sub Branch",
    address:
      " WealthyIn Customer Services Pvt Ltd <br /> Shop No: 101, Shivam Complex, <br /> Old Delhi Road, Opposite HUDA Office,<br /> Sector-14, Gurugram, <br /> Haryana - 122001, <br /> INDIA",
  },
  {
    isMainBranch: false,
    city: "Surat",
    url: `${WealthyEnv.CDN_URL}/articles/surat2.jpg`,
    branchType: "Sub Branch",
    address:
      "405, 4th Floor, Milestone Acropolis, <br/> Ambika Niketan, Athwa, <br/> Surat, Gujarat - 395007 <br /> INDIA",
  },
  {
    isMainBranch: false,
    city: "Kanpur",
    url: `${WealthyEnv.CDN_URL}/articles/Kanpur.jpg`,
    branchType: "Sub Branch",
    address:
      "16/34 3rd Floor Sai Arcade, <br /> Bhargav Estate, Near Income Tax Office, <br/> Civil Lines, Kanpur, <br /> Uttar Pradesh - 208001, <br /> INDIA",
  },
  {
    isMainBranch: false,
    city: "Chennai",
    url: `${WealthyEnv.CDN_URL}/articles/chennai.jpg`,
    branchType: "Sub Branch",
    address:
      "WOCO co-work Space No 3020, <br/> Old Y-Block, 4th St, <br/> Shanthi Colony, Anna Nagar, <br/> Chennai, Tamil Nadu - 600040 <br /> INDIA",
  },
  {
    isMainBranch: false,
    city: "Prayagraj",
    url: `${WealthyEnv.CDN_URL}/articles/prayagraj.jpeg`,
    branchType: "Sub Branch",
    address:
      "4 C, S N Towers, <br/> Maharishi Dayanand Marg, <br/> Opp Radio Station, Civil Lines, <br/> Allahabad, Uttar Pradesh – 211001 <br /> INDIA",
  },
  {
    isMainBranch: false,
    city: "Varanasi",
    url: `${WealthyEnv.CDN_URL}/articles/varanasi.jpeg`,
    branchType: "Sub Branch",
    address:
      "4th Floor, <br/> Anant Complex, Sigra, <br/> Varanasi, Uttar Pradesh – 221010. <br /> INDIA",
  },
  {
    isMainBranch: false,
    city: "Chandigarh",
    url: `${WealthyEnv.CDN_URL}/articles/chandigarh-img.jpeg`,
    branchType: "Sub Branch",
    address:
      "SCO 130-131, Fourth Floor, <br/> Above Ujjivan Small Finance Bank <br/> Sector 34A, Chandigarh – 160022. <br /> INDIA",
  },
];

export default WealthyOfficesList;
